// src/components/navbar/Navbar.js
import React from 'react';
import { LogoWithStatus } from '../LogoWithStatus';
import './navbar.css';

const Navbar = () => {
  return (
    <div className="navbar">
      <LogoWithStatus 
        src="/logo.svg"
        alt="Logo"
        className="logo navbar-logo"
      />
    </div>
  );
};

export default Navbar;